import React from 'react';
import PropTypes from 'prop-types';
import { FilterX } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../components/ui/select';

const getFilterValue = (columnFilters, filterId) =>
  columnFilters.find((filter) => filter.id === filterId)?.value || 'all';

const AdminStocksFilters = ({ columnFilters, providerOptions, serviceDeskOptions, table }) => {
  const serviceDeskFilter = getFilterValue(columnFilters, 'serviceDeskName');
  const providerFilter = getFilterValue(columnFilters, 'provider');
  const stockStatusFilter = getFilterValue(columnFilters, 'stockStatus');
  const hasActiveFilters =
    serviceDeskFilter !== 'all' ||
    providerFilter !== 'all' ||
    stockStatusFilter !== 'all';

  return (
    <>
      <Select
        value={serviceDeskFilter}
        onValueChange={(value) => {
          table.getColumn('serviceDeskName')?.setFilterValue(
            value === 'all' ? undefined : value
          );
        }}
      >
        <SelectTrigger className="w-[200px]">
          <SelectValue placeholder="Tous les service desks" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Tous les service desks</SelectItem>
          {serviceDeskOptions.map((serviceDesk) => (
            <SelectItem key={serviceDesk.id} value={serviceDesk.name}>
              {serviceDesk.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select
        value={providerFilter}
        onValueChange={(value) => {
          table.getColumn('provider')?.setFilterValue(value === 'all' ? undefined : value);
        }}
      >
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Toutes les sources" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Toutes les sources</SelectItem>
          {providerOptions.map((provider) => (
            <SelectItem key={provider.id} value={provider.label}>
              {provider.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select
        value={stockStatusFilter}
        onValueChange={(value) => {
          table.getColumn('stockStatus')?.setFilterValue(
            value === 'all' ? undefined : value
          );
        }}
      >
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Tous les statuts" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Tous les statuts</SelectItem>
          <SelectItem value="Available">Disponible</SelectItem>
          <SelectItem value="Low stock">Stock faible</SelectItem>
          <SelectItem value="Out of stock">Rupture</SelectItem>
        </SelectContent>
      </Select>

      {hasActiveFilters && (
        <Button
          onClick={() => table.resetColumnFilters()}
          variant="outline"
          className="flex items-center gap-2 whitespace-nowrap"
        >
          <FilterX className="h-4 w-4" />
          Effacer les filtres
        </Button>
      )}
    </>
  );
};

AdminStocksFilters.propTypes = {
  columnFilters: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      value: PropTypes.any,
    })
  ).isRequired,
  providerOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  serviceDeskOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  table: PropTypes.shape({
    getColumn: PropTypes.func.isRequired,
    resetColumnFilters: PropTypes.func.isRequired,
  }).isRequired,
};

export { AdminStocksFilters };
